import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, Suspense, lazy } from 'react';

// Styles
import './styles/main.css';

// Components
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import FloatingSocialButtons from './components/FloatingSocialButtons/FloatingSocialButtons';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';

// Performance monitoring
import performanceMonitor from './utils/performanceMonitor';

// Lazy load pages for better performance
const Home = lazy(() => import('./pages/Home/Home'));
const About = lazy(() => import('./pages/About/About'));
const Projects = lazy(() => import('./pages/Projects/Projects'));
const Services = lazy(() => import('./pages/Services/Services'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const Downloads = lazy(() => import('./pages/Downloads/Downloads'));
const Blog = lazy(() => import('./pages/Blog/Blog'));
const Careers = lazy(() => import('./pages/Careers/Careers'));

// Loading component
const PageLoader = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '50vh',
    fontSize: '1.2rem',
    color: '#0ea5e9'
  }}>
    Loading...
  </div>
);

function App() {
  useEffect(() => {
    performanceMonitor?.mark?.('app-mounted');
  }, []);

  return (
    <Router>
       <ScrollToTop />
      <Header />
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={
            <>
              <Home />
             <Footer />
            </>
          } />
          <Route path="/about" element={
            <>
              <About />
              <Footer />
            </>
          } />
          <Route path="/projects" element={
            <>
              <Projects />
              <Footer />
            </>
          } />
          <Route path="/services" element={
            <>
              <Services />
              <Footer />
            </>
          } />
          <Route path="/contact" element={
            <>
              <Contact />
              <Footer />
            </>
          } />
          <Route path="/contact-us" element={
            <>
              <Contact />
              <Footer />
            </>
          } />
            <Route path="/blog" element={
            <>
              <Blog />
              <Footer />
            </>
          } />
          <Route path="/downloads" element={
            <>
              <Downloads />
              <Footer />
            </>
          } />
           <Route path="/careers" element={
            <>
              <Careers />
              <Footer />
            </>
          } />
        </Routes>
      </Suspense>
        <FloatingSocialButtons />
    </Router>
  );
}

export default App;
